<template>
  <div class="page-partners__item">
    <div class="page-partners__partners-info"
         @click="onChangePartner()"
         :class="isActive(partner.id) ? 'active-partner' : ''"
    >
      <div v-if="partner.logo">
        <img :src="partner.logo" class="page-partners__partners-img" alt="logo">
      </div>
      <div v-else>
        <p class="page-partners__partners-logo-text">
          {{ partner.name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'partnersLink',
  components: {},

  props: {
    partner: {
      type: Object,
      default() {
        return {}
      },
      required: false,
    },
    value: { type: Number, default: '', required: false },
    currentPartner: { type: Number, default: '', required: false },
  },


  data() {
    return {
      isActivePartners: false
    }
  },

  methods: {
    isActive(id) {
      return this.currentPartner === id
    },

    onChangePartner() {
      this.isActivePartners = !this.isActivePartners
      this.$emit('on-change-partner', this.value)
    }
  },
}
</script>
